module.exports = __webpack_public_path__ + "static/auto_import_new-10f5fc3acc03a38333e27936154dd4a5.png";